import React, { useState, useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SuperAdminLogin from './SuperAdminLogin';
import SuperAdminDashboard from './SuperAdminDashboard';
import ListaNegocios from './ListaNegocios';
import FormNegocio from './FormNegocio';
import DetalleNegocio from './DetalleNegocio';
import ConfiguracionPlanes from './ConfiguracionPlanes';
import HealthDashboard from './HealthDashboard';

export default function SuperAdminApp() {
    const [autenticado, setAutenticado] = useState(false);
    const [vista, setVista] = useState('dashboard');
    const [params, setParams] = useState({});
    const [menuOpen, setMenuOpen] = useState(false);

    // Verificar si ya hay sesión activa
    useEffect(() => {
        const token = localStorage.getItem('superadmin_token');
        const user = localStorage.getItem('superadmin_user');
        if (token && user) {
            setAutenticado(true);
        }
    }, []);

    const handleLogin = (data) => {
        setAutenticado(true);
        setVista('dashboard');
    };

    const handleLogout = () => {
        localStorage.removeItem('superadmin_token');
        localStorage.removeItem('superadmin_user');
        setAutenticado(false);
        setVista('dashboard');
    };

    const handleAuthError = () => {
        localStorage.removeItem('superadmin_token');
        localStorage.removeItem('superadmin_user');
        setAutenticado(false);
        setVista('dashboard');
    };

    const handleNavigate = (destino, extra) => {
        setVista(destino);
        setParams({ extra });
        setMenuOpen(false);
    };

    const handleBack = () => {
        setVista('dashboard');
        setParams({});
    };

    const handleSaved = () => {
        setVista('negocios');
        setParams({});
    };

    if (!autenticado) {
        return (
            <>
                <SuperAdminLogin onLogin={handleLogin} />
                <ToastContainer position="top-right" autoClose={3000} />
            </>
        );
    }

    const userData = JSON.parse(localStorage.getItem('superadmin_user') || '{}');

    const navItems = [
        { id: 'dashboard', label: 'Dashboard', icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6' },
        { id: 'negocios', label: 'Negocios', icon: 'M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4' },
        { id: 'planes', label: 'Planes', icon: 'M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A2 2 0 013 12V7a4 4 0 014-4z' },
        { id: 'health', label: 'Health', icon: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z' },
    ];

    return (
        <div style={{
            minHeight: '100vh',
            background: '#f3f4f6',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
        }}>
            {/* NAVBAR */}
            <nav style={{
                background: '#fff',
                borderBottom: '1px solid #e5e7eb',
                position: 'sticky',
                top: 0,
                zIndex: 100
            }}>
                <div style={{
                    maxWidth: '1200px',
                    margin: '0 auto',
                    padding: '0 24px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    height: '60px'
                }}>
                    {/* Logo + Nav */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '32px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <div style={{
                                width: '32px', height: '32px',
                                background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
                                borderRadius: '8px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                                    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                                </svg>
                            </div>
                            <span style={{ fontWeight: 700, fontSize: '16px', color: '#1a1a2e', letterSpacing: '-0.3px' }}>
                                Komity <span style={{ color: '#6b7280', fontWeight: 400 }}>Super Admin</span>
                            </span>
                        </div>

                        {/* Nav Links Desktop */}
                        <div style={{ display: 'flex', gap: '4px' }}>
                            {navItems.map(item => (
                                <button key={item.id} onClick={() => handleNavigate(item.id)}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '6px',
                                        padding: '8px 16px',
                                        background: vista === item.id ? '#f3f4f6' : 'transparent',
                                        border: 'none',
                                        borderRadius: '8px',
                                        color: vista === item.id ? '#1a1a2e' : '#6b7280',
                                        fontSize: '13px',
                                        fontWeight: vista === item.id ? 600 : 500,
                                        cursor: 'pointer',
                                        transition: 'all 0.15s'
                                    }}>
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d={item.icon}/>
                                    </svg>
                                    {item.label}
                                </button>
                            ))}
                        </div>
                    </div>

                    {/* User Menu */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <span style={{ fontSize: '13px', color: '#6b7280' }}>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ verticalAlign: 'middle', marginRight: '4px' }}>
                                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
                            </svg>
                            {userData.nombre || 'Admin'}
                        </span>
                        <button onClick={handleLogout} style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            padding: '8px 14px',
                            background: '#fff',
                            border: '1.5px solid #e5e7eb',
                            borderRadius: '8px',
                            color: '#ef4444',
                            fontSize: '12px',
                            fontWeight: 600,
                            cursor: 'pointer',
                            transition: 'all 0.15s'
                        }}>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/>
                            </svg>
                            Salir
                        </button>
                    </div>
                </div>
            </nav>

            {/* CONTENIDO */}
            <div>
                {vista === 'dashboard' && (
                    <SuperAdminDashboard onNavigate={handleNavigate} onAuthError={handleAuthError} />
                )}
                {vista === 'negocios' && (
                    <ListaNegocios onNavigate={handleNavigate} filtroEstado={params.extra} onAuthError={handleAuthError} />
                )}
                {vista === 'nuevo' && (
                    <FormNegocio onClose={handleBack} onSaved={handleSaved} onAuthError={handleAuthError} />
                )}
                {vista === 'detalle' && (
                    <DetalleNegocio
                        negocioId={params.extra}
                        onBack={handleBack}
                        onEdit={(id) => handleNavigate('editar', id)}
                        onAuthError={handleAuthError}
                    />
                )}
                {vista === 'editar' && (
                    <FormNegocio
                        negocioId={params.extra}
                        onClose={handleBack}
                        onSaved={handleSaved}
                        onAuthError={handleAuthError}
                    />
                )}
                {vista === 'planes' && (
                    <ConfiguracionPlanes onAuthError={handleAuthError} />
                )}
                {vista === 'health' && (
                    <HealthDashboard onAuthError={handleAuthError} />
                )}
            </div>
            <ToastContainer position="top-right" autoClose={3000} />
        </div>
    );
}
